import React, { useState } from 'react';
import { useSnackbar } from 'notistack';

//** material ui components */
import Button from '@material-ui/core/Button';

//** api utils */
import { getApi } from '../../api';

function parseDate(value) {
  return new Date(value).toLocaleString('es-CR', {
    hour12: true,
  });
}

function DetailBooking({
  userId,
  bookingId,
  status,
  departureDatetime,
  returnDatetime,
  travelType,
  origin,
  destination,
  secondDestination,
  secondOrigin,
  passengersNumber,
  observations,
  service,
  setUpdateBooking,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelBooking = async () => {
    setIsLoading(true);
    try {
      // If the booking is still in the 'requested' state, mark it as 'denied' to indicate rejection.
      // Otherwise, mark it as 'cancelled' to indicate that an approved booking was cancelled.
      const newStatus = status === 'requested' ? 'denied' : 'cancelled';
      const response = await getApi().put(`/users/${userId}/bookings/${bookingId}`, {status: newStatus});
      if (response.status === 200) {
        enqueueSnackbar(`Solicitud ${newStatus === 'cancelled' ? 'cancelada': 'rechazada'}`, {
          variant: 'success',
        });
        setUpdateBooking({
          isUpdated: true,
          bookingId: bookingId,
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('No se pudo cancelar la solicitud por favor contactar al administrador', {
        variant: 'error',
      });
    }
    setIsLoading(false);
  };

  return (
    <div>
      <p>{`Código: #${bookingId}`}</p>
      <p>{`Estado: ${status}`}</p>
      <p>{`Tipo de viaje: ${travelType}`}</p>
      <p>{`Fecha de salida: ${parseDate(departureDatetime)}`}</p>
      <p>{`Fecha de regreso: ${returnDatetime ? parseDate(returnDatetime) : '--'}`}</p>
      <p>{`Origen: ${origin}`}</p>
      <p>{`Destino: ${destination}`}</p>
      <p>{`Cantidad de pasajeros: ${passengersNumber}`}</p>
      {/* <p>{``}</p>, ,<p>{``}</p> */}
      <p>{`Observaciones: ${observations}`}</p>
      {service && (
        <>
          <p>{`Chofer: ${service.driver.full_name}`}</p>
          <p>{`Vehículo: Placa #${service.vehicle.license_plate}`}</p>
        </>
      )}

      {['approved', 'requested'].includes(status) && (
        <Button
          variant="contained"
          color="secondary"
          disabled={isLoading}
          onClick={handleCancelBooking}
        >
          {!isLoading ? 'CANCELAR' : 'PROCESANDO...'}
        </Button>
      )}
    </div>
  );
}

export default DetailBooking;
